import { render, staticRenderFns } from "./TargetSystemImport.vue?vue&type=template&id=4880f538&scoped=true&"
import script from "./TargetSystemImport.vue?vue&type=script&lang=js&"
export * from "./TargetSystemImport.vue?vue&type=script&lang=js&"
import style0 from "./TargetSystemImport.vue?vue&type=style&index=0&id=4880f538&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4880f538",
  null
  
)

export default component.exports